import React from 'react';
import { Icon } from './Icon';

export const AlertIcon = React.memo((props) => (
  <Icon assetName="icon-alert.svg" {...props} />
));
